import React, { useEffect, useState } from 'react';
import { fetchgetAccumulatedLosses } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import TableHeader from '../../Custom/TableHeader';
import ChartLoader from '../../Loaders/ChartLoader';

const ChartAccumulatedLosses = ({ type, id }) => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const checkToken = await Auth();
      if (checkToken) {
        setLoading(true);
        fetchgetAccumulatedLosses(type, id).then((response) => {
          setLoading(false);
          const { statusCode, result } = response.data;
          setData(statusCode === 200 ? result : []);
        });
      }
    }
    fetchData();
  }, [type, id]);

  if (isLoading) {
    return <ChartLoader height="150" width="600" />;
  }
  return (
    <TableHeader title={'Accumulated Losses'}>
      <table className="tbl">
        <thead>
          <tr>
            <th>Timescale</th>
            <th>Losses (kWh)</th>
          </tr>
        </thead>
        <tbody>
          {data.map((losses, i) => (
            <tr key={i}>
              <td width="50%">{losses.interval}</td>
              <td width="50%">{losses.accumulatedLosses_KWh} </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableHeader>
  );
};
export default ChartAccumulatedLosses;
